<template>
  <div class="member-profile-tab">
    <div class="tab-wrapper">
      <div
        v-for="(menu, index) in tabMenus"
        :key="index"
        :class="['tab-menu', { 'active': index == tabIndex }]"
        @click="tabIndex = index"
      >
        {{ $t(`common.memberTabMenus.${menu}`) }}
      </div>
    </div>
    <div class="menu-wrapper">
      <menu-profile
        v-if="tabMenus[tabIndex] === 'profile'"
        ref="menuProfile"
        :myself="myself"
        :user="user"
        @onClickUpdateUser="onClickUpdateUser"
      />
      <menu-personal-settings
        v-if="this.myself && tabMenus[tabIndex] === 'personalSettings'"
        ref="menuPersonalSettings"
        :user="user"
        @onClickUpdateUserSettings="onClickUpdateUserSettings"
      />
      <private-chat-posts-container
        v-else-if="tabMenus[tabIndex] === 'privateChat'"
        :user="user"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MenuProfile from '@/components/molecules/memberProfileTab/MenuProfile'
import MenuPersonalSettings from '@/components/molecules/memberProfileTab/MenuPersonalSettings'
import PrivateChatPostsContainer from '@/components/organisms/PrivateChatPostsContainer'

export default {
  name: 'MemberProfileTab',
  components: {
    MenuProfile,
    MenuPersonalSettings,
    PrivateChatPostsContainer
  },
  props: {
    myself: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => {}
    },
    defaultMenu: {
      type: String,
      default: 'profile'
    }
  },
  computed: {
    tabMenus: function() {
      return [
        'profile',
        'personalSettings',
        'privateChat',
        // TODO: スケジュール/業務日報
        // 'schedule',
        // 'report'
      ].filter((menu) => {
        if (this.myself) {
          return menu !== 'privateChat'
        } else {
          return menu !== 'personalSettings'
        }
      })
    }
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  methods: {
    async onClickUpdateUser(editUser) {
      this.$refs.menuProfile.editMyProfileDisabled = true
      await this.apiPutAuth(editUser)
      this.$refs.menuProfile.editMyProfileModal = this.$refs.menuProfile.editMyProfileDisabled = false
    },
    async onClickUpdateUserSettings(editUser) {
      this.$refs.menuPersonalSettings.editPersonalSettingsDisabled = true
      await this.apiPutAuth(editUser)
      this.$refs.menuPersonalSettings.editPersonalSettingsModal = this.$refs.menuPersonalSettings.editPersonalSettingsDisabled = false
    },
    ...mapActions({
      apiPutAuth: 'auth/update',
    })
  },
  mounted() {
    // NOTE: 同一routeでくるとトリガー出来ない
    const defaultTabIndex = this.tabMenus.indexOf(this.defaultMenu)
    if (defaultTabIndex > 0) {
      this.tabIndex = defaultTabIndex
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.member-profile-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tab-wrapper {
  display: flex;
  border-bottom: 1px solid $dark-border-color;
  z-index: 1;
  min-height: 36px;
  overflow-x: auto;

  .tab-menu {
    font-size: 13px;
    font-weight: 600;
    color: $light-text-color;
    border-bottom: 4px solid $light-gray-color;
    padding: 0 15px 12px 15px;
    cursor: pointer;
    word-break: keep-all;

    &:first-child {
      margin-left: 0;
      padding-left: 15px;

      @include mq(md) {
        margin-left: 15px;
      }
    }

    &.active {
      color: $primary-color;
      border-bottom: 4px solid $primary-color;
    }
  }
}

.menu-wrapper {
  height: calc(100% - 36px);
}
</style>
